import { motion } from "framer-motion";

export default function Hero() {
  return (
    <section className="hero" id="home">
      <div className="hero-container">
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="hero-content"
          style={{ transformStyle: 'preserve-3d' }}
        >
          <span className="hero-tagline">Frontend Developer</span>
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            Crafting Digital Experiences <br />
            <span>That Matter.</span>
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="hero-subtitle"
          >
            I build high-performance, accessible, and visually stunning web applications
            using modern technologies like React, Tailwind, and Framer Motion.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
            className="hero-btns"
          >
            <a href="#projects" className="btn-primary">View My Work</a>
            <a href="#contact" className="btn-secondary">Let's Talk</a>
          </motion.div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 50, rotateY: -20 }}
          animate={{ opacity: 1, x: 0, rotateY: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          whileHover={{ rotateY: 15, rotateX: -5, scale: 1.05 }}
          className="hero-image-container"
        >
          <div className="hero-image-wrapper glass">
            <img
              src="assets/images/ojopicture.jpg"
              alt="Ojo Azeez Olawale"
              className="hero-img"
            />
          </div>
        </motion.div>
      </div>

      {/* Decorative Blob */}
      <div className="hero-blob"></div>
    </section>
  );
}
